/**
 * The renewals routes — the register (U5.5) and the customer reminder draft queue (U2/5.6).
 *
 * ⚠ BOTH PATHS ARE COPIED FROM THE NAV REGISTRY, NOT INVENTED. `domain/nav.ts`'s Renewals
 * section carries `path: 'renewals'` and `path: 'renewal-drafts'`, and a route that
 * disagreed with either would give the sidebar a dead link — the same failure
 * `registers/routes.tsx` records for `deployed`.
 *
 * ⚠ AND `renewal-drafts` MATCHES THE API's OWN PATH SEGMENT, which is not a coincidence
 * worth leaving to chance: `renewals.controller.ts` mounts `GET /countries/:cc/renewal-drafts`
 * and `POST /countries/:cc/renewal-drafts/:id/send`. Naming the screen's URL after the
 * resource means anybody reading a server log can find the screen that produced it.
 *
 * NO PROVIDER LAYOUT, and the draft queue is the one that had to earn that. The screens
 * `features/quotes/routes.tsx` wraps in a `ToastProvider` do so because their action
 * NAVIGATES and the message must outlive the move. Sending a reminder navigates nowhere:
 * the outcome belongs on the card and in the sent-this-session panel, where it stays put
 * and can still be read ten minutes later. A toast for "this letter went to this customer"
 * would scroll away in four seconds, which is the wrong lifetime for that fact.
 */

import type { RouteObject } from 'react-router-dom';

import { RenewalsPage } from './RenewalsPage';
import { RenewalDraftsPage } from './RenewalDraftsPage';

export const renewalsRoutes: RouteObject[] = [
  { path: 'renewals', element: <RenewalsPage /> },
  { path: 'renewal-drafts', element: <RenewalDraftsPage /> },
];
